/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FAnonymousType181
 */
export interface FAnonymousType181 {
    /**
     * 
     * @type {number}
     * @memberof FAnonymousType181
     */
    sessionId?: number;
}

/**
 * Check if a given object implements the FAnonymousType181 interface.
 */
export function instanceOfFAnonymousType181(value: object): value is FAnonymousType181 {
    return true;
}

export function FAnonymousType181FromJSON(json: any): FAnonymousType181 {
    return FAnonymousType181FromJSONTyped(json, false);
}

export function FAnonymousType181FromJSONTyped(json: any, ignoreDiscriminator: boolean): FAnonymousType181 {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
    };
}

export function FAnonymousType181ToJSON(json: any): FAnonymousType181 {
    return FAnonymousType181ToJSONTyped(json, false);
}

export function FAnonymousType181ToJSONTyped(value?: FAnonymousType181 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionId': value['sessionId'],
    };
}

